"use client";

import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";

import { LoadingSpinner } from "~/components/loading-spinner";
import { Prose } from "~/components/prose";
import { StructuredText } from "~/components/structured-text";
import { H2 } from "~/components/typography";
import { Dialog, DialogContent, DialogTrigger } from "~/components/ui/dialog";
import { graphql } from "~/lib/dato-graphql";
import { getDatoLocale } from "~/lib/dato-utils";
import { useTrack } from "~/lib/use-track";
import { useDatoQuery } from "~/lib/use-urql-queries";

const TRIP_TRANSFER_INFO_QUERY = graphql(`
  query TripTransferInfo($locale: SiteLocale!) {
    tripTransferArticle(locale: $locale, fallbackLocales: en) {
      content {
        blocks
        links
        value
      }
    }
  }
`);

export function LearnMoreTransfers() {
  const track = useTrack();
  const t = useTranslations("TripDetails");
  const locale = useLocale();
  const [{ data, fetching: isLoading }] = useDatoQuery({
    query: TRIP_TRANSFER_INFO_QUERY,
    variables: { locale: getDatoLocale(locale) },
  });

  return (
    <Dialog
      onOpenChange={(open) => {
        if (open) {
          track({ name: "Open Transfers Modal" });
        }
      }}
    >
      <DialogTrigger asChild>
        <button type="button" className="text-prune-500 font-medium">
          {t("included")}
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-screen overflow-y-scroll">
        <div className="mx-auto my-8 max-w-4xl">
          <H2 className="mb-4">Transfers</H2>
          <div className="mb-4">
            {isLoading || !data?.tripTransferArticle ? (
              <LoadingSpinner />
            ) : (
              <Prose>
                <StructuredText data={data.tripTransferArticle.content} />
              </Prose>
            )}
          </div>
          <div className="flex w-full grid-cols-[1.5fr_1.5fr_0.6fr] flex-col gap-2 *:w-full sm:grid sm:flex-row sm:gap-6 sm:*:h-full sm:*:object-cover [&>img]:rounded-lg sm:[&>img]:rounded-2xl">
            <Image
              alt="Train"
              src="/transfers/AdobeStock_192107646.jpeg"
              width={5885}
              height={3923}
            />
            <Image
              alt="Train"
              src="/transfers/AdobeStock_602779466.jpeg"
              width={6048}
              height={4032}
            />
            <Image
              alt="Train"
              src="/transfers/scmaglev-railway-park.jpg"
              width={1960}
              height={3268}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
